import React from "react";
import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";

import { useNotificationListener } from "@/config/useNotificationListener";

const Layout: React.FC = () => {
  useNotificationListener();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <Box sx={{ flex: 1 }}>
        <Outlet />
      </Box>
    </Box>
  );
};

export default Layout;
